import { Box, styled, Typography } from '@mui/material';

interface StatisticWrapperProps {
  direction?: 'row' | 'column';
  align?: 'left' | 'right' | 'center';
}

export const StatisticWrapper = styled(Box)<StatisticWrapperProps>(
  ({ direction = 'row', align = 'left' }) => ({
    display: 'flex',
    flexDirection: direction,
    alignItems: direction === 'row' ? 'center' : 'flex-start',
    gap: direction === 'row' ? 4 : 0,
    justifyContent: align,
  }),
);

export const TitleWrapper = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.text.second,
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  color: 'inherit',
  whiteSpace: 'nowrap',
  gap: theme.spacing(0.5),
}));

export const ValueWrapper = styled(Typography)(() => ({
  fontSize: 'inherit',
  fontWeight: 'inherit',
  whiteSpace: 'nowrap',
}));

export const PrefixWrapper = styled(Typography)({
  fontSize: 'inherit',
  fontWeight: 'inherit',
});

export const SuffixWrapper = styled(Typography)({
  fontSize: 'inherit',
  fontWeight: 'inherit',
});
